import axios from 'axios';
import pathToRegexp from 'path-to-regexp';
import * as cacheManager from '@gaoding/cache';
import to from 'await-to-js';

function compose() {
    var adapters = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        adapters[_i] = arguments[_i];
    }
    for (var _a = 0, adapters_1 = adapters; _a < adapters_1.length; _a++) {
        var fn = adapters_1[_a];
        if (typeof fn !== 'function') {
            throw new TypeError('Adapter must be function!');
        }
    }
    return function composedAxiosAdapter(config) {
        var index = -1;
        return dispatch(0);
        function dispatch(i) {
            if (i <= index) {
                return Promise.reject(new Error('next() called multiple times'));
            }
            index = i;
            var fn = adapters[i];
            if (i === adapters.length) {
                return Promise.resolve();
            }
            try {
                return Promise.resolve(fn(config, dispatch.bind(null, i + 1)));
            }
            catch (err) {
                return Promise.reject(err);
            }
        }
    };
}

var defaultAdapter = axios.defaults.adapter;
function defaultRequestMiddleware() {
    return function defaultRequestMiddlewareAdapter(config) {
        return defaultAdapter(config);
    };
}

function RESTfulMiddleware() {
    return function RESTfulMiddlewareAdapter(config, next) {
        var _a = config.url, url = _a === void 0 ? '' : _a;
        var domain = getDomain(url);
        var path = url.slice(domain.length);
        var tokens = pathToRegexp.parse(path);
        var toPath = pathToRegexp.compile(path);
        var params = config.params;
        var data = config.data;
        var dataIsObject = false;
        if (!isDef(params)) {
            params = {};
        }
        try {
            if (isDef(data)) {
                data = JSON.parse(data);
                dataIsObject = true;
            }
        }
        catch (e) {
            // ignore
        }
        var resolvedPath = toPath(Object.assign({}, params, dataIsObject ? data : {}));
        for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
            var token = tokens_1[_i];
            if (!(token instanceof Object))
                continue;
            if (token.name in params) {
                delete params[token.name];
            }
            else if (dataIsObject && token.name in data) {
                delete data[token.name];
            }
        }
        config.url = domain + resolvedPath;
        config.params = params;
        if (dataIsObject) {
            config.data = JSON.stringify(data);
        }
        return next();
    };
}
function getDomain(url) {
    var domain = '';
    var found = url.match(/^https?:\/\/[^/]*/i);
    if (found) {
        domain = found[0];
    }
    return domain;
}
function isDef(value) {
    return value !== undefined && value !== null;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

var isBuffer = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
};

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

var utils = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

// @ts-ignore
function buildSortedURL() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var builtURL = buildURL.apply(void 0, args);
    var _a = builtURL.split('?'), urlPath = _a[0], queryString = _a[1];
    if (queryString) {
        var paramsPair = queryString.split('&');
        return urlPath + "?" + paramsPair.sort().join('&');
    }
    return builtURL;
}

function cacheMiddleware(options) {
    if (options === void 0) { options = {}; }
    var _a = options.enableByDefault, enableByDefault = _a === void 0 ? true : _a, _b = options.cacheFlag, cacheFlag = _b === void 0 ? 'cache' : _b, _c = options.cacheType, cacheType = _c === void 0 ? 'sessionCache' : _c, _d = options.cacheTime, cacheTime = _d === void 0 ? '10m' : _d;
    return function cacheMiddlewareAdapter(config, next) {
        return __awaiter(this, void 0, void 0, function () {
            var url, method, params, paramsSerializer, forceUpdate, cacheConfig, useCache, cache, index, response, _a, reason, response_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = config.url, method = config.method, params = config.params, paramsSerializer = config.paramsSerializer, forceUpdate = config.forceUpdate;
                        cacheConfig = config[cacheFlag] !== null && typeof config[cacheFlag] === 'object'
                            ? config[cacheFlag]
                            : {};
                        useCache = config[cacheFlag] !== void 0 && config[cacheFlag] !== null
                            ? config[cacheFlag]
                            : enableByDefault;
                        if (!(method === 'get' && useCache)) return [3 /*break*/, 3];
                        cache = cacheManager[cacheConfig.type || cacheType];
                        index = buildSortedURL(url, params, paramsSerializer);
                        response = cache.get(index);
                        if (!(!response || forceUpdate)) return [3 /*break*/, 2];
                        return [4 /*yield*/, to(next())];
                    case 1:
                        _a = _b.sent(), reason = _a[0], response_1 = _a[1];
                        if (reason) {
                            cache.remove(index);
                            throw reason;
                        }
                        cache.set(index, response_1, {
                            time: cacheConfig.time || cacheTime
                        });
                        return [2 /*return*/, response_1];
                    case 2: return [2 /*return*/, response];
                    case 3: return [2 /*return*/, next()];
                }
            });
        });
    };
}

function paginationMiddleware() {
    return function paginationMiddlewareAdapter(config, next) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rawPagination;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, next()];
                    case 1:
                        response = _a.sent();
                        if (response.headers['x-pagination']) {
                            try {
                                rawPagination = response.headers['x-pagination'];
                                response.pagination = new Pagination(JSON.parse(rawPagination));
                            }
                            catch (e) {
                                // ignore
                            }
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
}
var Pagination = /** @class */ (function () {
    function Pagination(info) {
        this.size = info.size;
        this.num = info.num;
        this.total = info.total;
    }
    Object.defineProperty(Pagination.prototype, "hasNextPage", {
        get: function () {
            return this.num < Math.ceil(this.total / this.size);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Pagination.prototype, "hasPrePage", {
        get: function () {
            return this.num > 1;
        },
        enumerable: true,
        configurable: true
    });
    Pagination.prototype.nextPage = function () {
        if (this.hasNextPage) {
            return this.num + 1;
        }
        return this.num;
    };
    Pagination.prototype.prePage = function () {
        if (this.hasPrePage) {
            return this.num - 1;
        }
        return this.num;
    };
    return Pagination;
}());

function preventDefaultMiddleware(options) {
    if (options === void 0) { options = {}; }
    var onError = options.onError;
    return function preventDefaultMiddlewareAdapter(config, next) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, reason, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, to(next())];
                    case 1:
                        _a = _b.sent(), reason = _a[0], response = _a[1];
                        if (reason) {
                            if (axios.isCancel(reason)) {
                                reason._defaultPrevented = true;
                            }
                            reason._defaultPrevented = reason._defaultPrevented || false;
                            reason.preventDefault = function preventDefault() {
                                reason._defaultPrevented = true;
                            };
                            setTimeout(function () {
                                if (!reason._defaultPrevented) {
                                    onError && onError(reason);
                                }
                            }, 0);
                            throw reason;
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
}

function isTokenLike(token) {
    return !!(token &&
        token.access_token &&
        token.access_token_expires_at &&
        token.refresh_token &&
        token.refresh_token_expires_at &&
        isString$1(token.access_token) &&
        isString$1(token.access_token_expires_at) &&
        isString$1(token.refresh_token) &&
        isString$1(token.refresh_token_expires_at));
}
function isString$1(val) {
    return typeof val === 'string';
}

function oauth2enticateMiddleware(options) {
    if (options === void 0) { options = {}; }
    var _a = options.enableByDefault, enableByDefault = _a === void 0 ? true : _a, _b = options.tokenFlag, tokenFlag = _b === void 0 ? 'token' : _b, _c = options.schema, schema = _c === void 0 ? 'Bearer' : _c, _d = options.validateError, validateError = _d === void 0 ? defaultValidateError : _d, refreshToken = options.refreshToken;
    var token;
    var isRefreshingToken = false;
    var requestQueue = [];
    function dispatchRefreshToken() {
        return __awaiter(this, void 0, void 0, function () {
            var _a, reason, newToken, _b, config, fulfilled, rejected;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        isRefreshingToken = true;
                        return [4 /*yield*/, to(refreshToken(token))];
                    case 1:
                        _a = _c.sent(), reason = _a[0], newToken = _a[1];
                        isRefreshingToken = false;
                        if (!reason) {
                            token = newToken;
                            setToken(tokenFlag, token);
                        }
                        else {
                            token = null;
                            localStorage.removeItem(tokenFlag);
                        }
                        while (requestQueue.length) {
                            _b = requestQueue.shift(), config = _b.config, fulfilled = _b.fulfilled, rejected = _b.rejected;
                            if (reason) {
                                rejected(reason);
                            }
                            else {
                                config.headers.Authorization = schema + " " + token.access_token;
                                if (config.baseURL && config.url && config.url.startsWith(config.baseURL)) {
                                    config.url = config.url.replace(config.baseURL, '');
                                }
                                axios
                                    .create()(config)
                                    .then(fulfilled, rejected);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    return function oauth2enticateMiddlewareAdapter(config, next) {
        return __awaiter(this, void 0, void 0, function () {
            var t, withCredentials, useToken, _a, reason, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!token) {
                            t = getToken(tokenFlag);
                            if (t) {
                                token = t;
                            }
                        }
                        withCredentials = config.withCredentials;
                        useToken = token && (withCredentials || enableByDefault);
                        if (!useToken) return [3 /*break*/, 2];
                        if (isRefreshingToken) {
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    requestQueue.push({
                                        config: config,
                                        fulfilled: resolve,
                                        rejected: reject
                                    });
                                })];
                        }
                        config.headers.Authorization = schema + " " + token.access_token;
                        return [4 /*yield*/, to(next())];
                    case 1:
                        _a = _b.sent(), reason = _a[0], response = _a[1];
                        if (reason) {
                            if (validateError(reason) && refreshToken) {
                                if (!isRefreshingToken) {
                                    dispatchRefreshToken();
                                }
                                return [2 /*return*/, new Promise(function (resolve, reject) {
                                        requestQueue.push({
                                            config: config,
                                            fulfilled: resolve,
                                            rejected: reject
                                        });
                                    })];
                            }
                            else {
                                throw reason;
                            }
                        }
                        else {
                            return [2 /*return*/, response];
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/, next()];
                }
            });
        });
    };
}
function defaultValidateError(error) {
    return (typeof error.response !== 'undefined' && error.response.status === 401);
}
function getToken(tokenFlag) {
    var rawToken = localStorage.getItem(tokenFlag);
    var token;
    if (rawToken) {
        try {
            var parsed = JSON.parse(rawToken);
            if (isTokenLike(parsed)) {
                token = parsed;
            }
        }
        catch (e) {
            // ignore
        }
    }
    return token;
}
function setToken(tokenFlag, token) {
    localStorage.setItem(tokenFlag, JSON.stringify(token));
}

export { RESTfulMiddleware as RESTful, cacheMiddleware as cache, compose, defaultRequestMiddleware as defaultRequest, oauth2enticateMiddleware as oauth2enticate, paginationMiddleware as pagination, preventDefaultMiddleware as preventDefault };
